import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { isPartialDate, sortPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import { TDocument, isMGCComplete, mgcScore } from '../utils';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { IMGADL, mgadl } from 'neuro-schemas';

const fm = (id: string, values?: { [key: string]: string }): React.JSX.Element => (
  <FormattedMessage id={id} values={values || {}} />
);

const getLatest = (
  type: 'mgc' | 'mgadl',
  docs: Array<TDocument>,
): { date: PartialDate | undefined; value: React.JSX.Element | string | undefined | number } | undefined => {
  const latestDoc = docs.filter(d => d._type === type).sort((n1, n2) => sortPartialDate(n2.date, n1.date))[0];
  if (!latestDoc) return undefined;
  switch (type) {
    case 'mgc': {
      const latest = latestDoc as IMGC;
      const dateOfLatest = latest.date;
      const valueOfLatest = isMGCComplete(latest)
        ? mgcScore(latest).toString()
        : latest.manualScore || latest.manualScore === 0
          ? latest.manualScore.toString()
          : '-';
      return {
        date: dateOfLatest,
        value: valueOfLatest,
      };
    }
    case 'mgadl': {
      const latest = latestDoc as IMGADL;
      return {
        date: latest.date ?? undefined,
        value: mgadl.calculateProgress(latest).yielded ?? '-',
      };
    }
  }
};

const FunctionalPerformanceMgravisDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const mgc = getLatest('mgc', documents);
  const mgadl = getLatest('mgadl', documents);

  return (
    <React.Fragment>
      <TileContentMaker
        type="specificList"
        data={[
          {
            date: isPartialDate(mgc?.date) ? formatPartialDate(mgc?.date) : '',
            title: fm('functionalPerformanceMgravis.mgcShort'),
            value: !mgc ? fm('functionalPerformanceMgravis.notEvaluated') : mgc?.value,
            key: 'mgc',
          },
          {
            date: isPartialDate(mgadl?.date) ? formatPartialDate(mgadl?.date) : '',
            title: fm('functionalPerformanceMgravis.mgadlShort'),
            value: !mgadl ? fm('functionalPerformanceMgravis.notEvaluated') : mgadl.value,
            key: 'mg-adl',
          },
        ]}
      />
    </React.Fragment>
  );
};

interface IOwnProps {
  documents: Array<TDocument>;
}

export default FunctionalPerformanceMgravisDash;
